import React from 'react';
import { Card, Layout } from 'antd';
import { AppstoreAddOutlined, TagsOutlined } from '@ant-design/icons';
import { Routes } from '../../../routes';
import { PageLinkCard } from '../../../components/pageLinkCard/PageLinkCard';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { useFeatureFlags } from '../../../featureFlags';
import { flags } from '../../../featureFlags/flags';

// NOTE: This page duplicates the "content-taxonomy" branch of the nav menu in AppView.js.
// See the shared-nav-config TODO at the top of AppView.js — the menu, these landing pages,
// and the home cards should eventually be driven from a single source of truth.
const ContentTaxonomyNav = () => {

    const breadcrumbs = [
        { name: 'Course Studio', path: Routes.Home.buildPath() },
        { name: 'Content Taxonomy' }
    ];

    const [ showCategories ] = useFeatureFlags( [ flags.CATEGORIES ] );

    return (
        <Layout className="content-taxonomy-nav-page">

            { /* Page header breadcrumbs */ }
            <Breadcrumbs crumbs={ breadcrumbs }/>

                <Card
                    className="content-taxonomy-nav-content link-card"
                    title="Content Taxonomy"
                >

                    <PageLinkCard
                        disabled={ !showCategories }
                        href={ Routes.ListCategoriesView.buildPath() }
                        icon={ <AppstoreAddOutlined />  }
                        title="Categories"
                        description="Create and edit categories."
                    />

                    <PageLinkCard
                        href={ Routes.TagsPage.buildPath() }
                        icon={ <TagsOutlined />  }
                        title="Tags"
                        description="Add, remove or edit tags."
                    />

                </Card>
        </Layout>
    );
};

export default ContentTaxonomyNav;
